/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupaddquestion2Inputs */

const en_signupaddquestion2 = /** @type {(inputs: Signupaddquestion2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add question`)
};

const de_signupaddquestion2 = /** @type {(inputs: Signupaddquestion2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frage hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add question" |
*
* @param {Signupaddquestion2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupaddquestion2 = /** @type {((inputs?: Signupaddquestion2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupaddquestion2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupaddquestion2(inputs)
	return de_signupaddquestion2(inputs)
});
export { signupaddquestion2 as "signupAddQuestion" }